import React,{useState} from "react";
import { Link, useNavigate } from "react-router-dom";
import "../css/footer.css"; // Import the CSS file
import { FaFacebookF, FaTwitter, FaInstagram, FaLinkedin, FaWhatsapp, FaPinterest } from "react-icons/fa";
import logo from "../images/24k2.png";

export const Footer = () => {
    const [email, setEmail] = useState("");

	const navigate = useNavigate();
	
    const handleSubscribe = (e) => {
      e.preventDefault();
      if (email.trim()) {
        alert(`Subscribed successfully with ${email}`);
        setEmail("");
      } else {
        alert("Please enter a valid email.");
      }
    };

  return (
    <footer className="footer">
      <div className="footer-container">
        {/* Column 1 - Logo & About */}
        <div className="footer-section" onClick={() => {navigate("/");}}>
            <img src={logo} alt="" />
        </div>

        {/* Column 2 - Quick Links */}
        <div className="footer-section">
          <h3>Quick Links</h3>
          <ul>
            <li><Link to="/about">About Us</Link></li>
            <li><Link to="/">Home</Link></li>
            <li><Link to="/new-projects/under-construction"> Ongoing Projects</Link></li>
            <li><Link to="/new-projects/ready-to-move"> Move in Ready Projects </Link></li>
            <li><Link to="/new-projects/new-launches">Just Launched Projects</Link></li>
            <li><Link to="/">Blog</Link></li>
          </ul>
        </div>

        {/* Column 3 - Contact Information */}
        <div className="footer-section">
          <h3>Contact Us</h3>
          <p>Email: admin@24krealtors.com</p>
          <p>Phone: +91 8838053254</p>
          <p>Location: Chennai, India</p>
        </div>


        {/* Column 4 - Newsletter Subscription */}
        <div className="footer-section newsletter">
          <h3>Subscribe to our Newsletter</h3>
          <form onSubmit={handleSubscribe} className="newsletter-form">
            <input
              type="email"
              placeholder="Enter your email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
            />
            <button type="submit">Subscribe</button>
          </form>
          <div className="social-icons">
          <a href="https://www.facebook.com/24krealtors" target="_blank" rel="noopener noreferrer"><FaFacebookF /></a>
          <a href="https://x.com/24K_Realtors" target="_blank" rel="noopener noreferrer"><FaTwitter /></a>
          <a href="https://www.instagram.com/24k_realtors/" target="_blank" rel="noopener noreferrer"><FaInstagram /></a>
          <a href="https://www.linkedin.com/company/24k-realtors/" target="_blank" rel="noopener noreferrer"><FaLinkedin /></a>
          <a href="https://in.pinterest.com/24k_realtors/" target="_blank" rel="noopener noreferrer"><FaPinterest /></a>
          <div> <a href="https://whatsapp.com/channel/0029VaE7JvmKWEKr2Pgvfj16" target="_blank" rel="noopener noreferrer"><FaWhatsapp /></a>
         </div>
         
        </div>
        <div> <a href="https://whatsapp.com/channel/0029VaE7JvmKWEKr2Pgvfj16" target="_blank" rel="noopener noreferrer">Join Our whatsapp Group For Updates</a>
         </div>
        </div>
      </div>

      {/* Social Media Links */}
      <div className="footer-bottom">
        
        <p>&copy; {new Date().getFullYear()} 24K Realtors. All rights reserved.</p>
      </div>
    </footer>
  );
};
